import React from "react"
import "./Spinner.scss"

export default class Spinner extends React.Component {

  render() {
    return <div className="Spinner">
      <div className="spinner-dot"/>
      <div className="spinner-dot"/>
      <div className="spinner-dot"/>
    </div>
  }

}

const Loading = () => <div className="tc pa4">
  <Spinner/>
</div>

export {Loading}


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js